import { render, staticRenderFns } from "./editOwnerMember.vue?vue&type=template&id=06432b38&scoped=true"
import script from "./editOwnerMember.vue?vue&type=script&lang=js"
export * from "./editOwnerMember.vue?vue&type=script&lang=js"
import style0 from "./editOwnerMember.vue?vue&type=style&index=0&id=06432b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06432b38",
  null
  
)

export default component.exports